import React, { Component, PropTypes } from "react";

import styled from "styled-components";

const MeterVerticalLine = styled.div`
  border-left: 1px solid ${props => props.theme.color[props.variant]};
  min-height:${props => props.height}px;
  display: block;
  margin-left:-1px;
  `;

const MeterArrowCaret = styled.div`
  margin:-12px 0px 0px -4px;
  display: inline-block;
  width: 0;
  vertical-align: middle;
  border-top: 12px solid ${props => props.theme.color[props.variant]};
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  content: "";
  `;


  const MeterArrowSection = styled.section`
  margin-left: ${props => props.left}%;
  position:absolute;
  z-index:999;
  margin-top: ${props => props.top}px;

  `;

const MeterArrow = ({ height, variant, left,top}) => {
	return (
		<MeterArrowSection left={left} top={top}>
			<MeterVerticalLine variant={variant} height={height} />
			<MeterArrowCaret variant={variant} />
		</MeterArrowSection>
	);
};

MeterArrow.defaultProps = {
	height: 50
};

MeterArrow.propTypes = {
	height: PropTypes.number,
	variant: PropTypes.string,
	left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	top: PropTypes.number,
};

export default MeterArrow;



// WEBPACK FOOTER //
// ./src/components/comparison/MeterArrow.js